export enum STATUS_CODE {
  success = 200,
  badRequest = 400,
  notFound = 404,
  internalServerError = 500
}
